export const defaultFormValues = {
  amount: null,
  defaultAmount: null,
  destination: null,
};
